/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React, { ReactElement } from 'react';

import ChartWrapper from './ChartWrapper';
import { bytesToUnitString } from '../../../../../utils/DataAmountUtils';
import { withTerminalHistoryChartHOCAndNoDataAvailableHOC, defaultChartOptions } from './WithTerminalHistoryChartHOC';
import { chartSeriesContent, ChartItemKeys, ChartType } from '../ChartSeriesItems';
import { getTooltipPointFormatterWithBytes } from '../ChartDataFormatterUtils';
import merge from 'lodash/merge';

interface CumulativeDataUsageChartProps {
  index: number;
  text: string;
  id: string;
  chart: Highcharts.Chart | null;
  children: ReactElement | ReactElement[];
}

const CumulativeDataUsageChart = (props: CumulativeDataUsageChartProps) => {
  const { index, text, id, children } = props;

  const chartName = text;
  return (
    <ChartWrapper name={chartName} id={id} index={index} chartType={ChartItemKeys.cumDataUsage}>
      {children}
    </ChartWrapper>
  );
};

const getChartOptions = () => {
  const defaultOptions = { ...defaultChartOptions(ChartType.area) };

  return merge(defaultOptions, {
    yAxis: {
      labels: {
        formatter(): string {
          // @ts-ignore
          return bytesToUnitString(this.value);
        },
      },
      title: {
        text: 'Data Usage',
      },
    },
    plotOptions: {
      area: {
        stacking: 'normal',
      },
    },
    tooltip: {
      pointFormatter: getTooltipPointFormatterWithBytes,
    },
  });
};

export default withTerminalHistoryChartHOCAndNoDataAvailableHOC(
  CumulativeDataUsageChart,
  ChartType.area,
  getChartOptions(),
  chartSeriesContent[ChartItemKeys.cumDataUsage],
  'cumDataUsageGapSec',
);
